import { render, staticRenderFns } from "./interview-confernce-page.html?vue&type=template&id=08158b2c&scoped=true&external"
import script from "./interview-confernce-page.js?vue&type=script&lang=js&external"
export * from "./interview-confernce-page.js?vue&type=script&lang=js&external"
import style0 from "./interview-confernce-page.scss?vue&type=style&index=0&id=08158b2c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08158b2c",
  null
  
)

export default component.exports